const PaymentModalContainerSkeleton = () => {
	return (
		<div className="animate-pulse space-y-4 rounded-2xl border border-stone-100 bg-white p-5 shadow-sm">
			<div className="flex justify-between gap-4">
				<div className="space-y-2">
					<div className="h-3 w-24 rounded bg-stone-200" />
					<div className="h-7 w-40 rounded bg-stone-200" />
				</div>
				<div className="h-9 w-28 rounded-full bg-stone-100" />
			</div>
			<div className="flex flex-col gap-5">
				<div className="flex items-start gap-4">
					<div className="size-16 shrink-0 rounded-2xl bg-stone-100 sm:size-20" />
					<div className="min-w-0 flex-1 space-y-2 pt-0.5">
						<div className="h-6 max-w-[240px] rounded bg-stone-200" />
						<div className="h-4 max-w-[180px] rounded bg-stone-100" />
					</div>
				</div>
				<div className="flex flex-col gap-4 border-t border-stone-100 pt-5">
					<div className="h-14 w-full rounded-xl bg-stone-50/80" />
					<div className="h-14 w-full rounded-xl bg-stone-50/80" />
				</div>
			</div>
		</div>
	);
};

export { PaymentModalContainerSkeleton };
